import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createWorkspaceImage } from "api/services/workspace-service";
import { getWorkspaceImageQueryKey } from "hooks/workspaceImage/queryKeys";
import { toUpsertWorkspaceImageRequest } from "hooks/workspaceImage/toUpsertWorkspaceImageRequest";

export const useCreateWorkspaceImage = (workspaceId: string) => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (file: File): Promise<File> => {
            const request = await toUpsertWorkspaceImageRequest(file);
            await createWorkspaceImage({ workspaceId, ...request });
            return file;
        },
        onSuccess: (file) => {
            queryClient.setQueryData<Blob | null>(getWorkspaceImageQueryKey(workspaceId), file);
        },
    });

    return {
        createWorkspaceImage: mutation.mutateAsync,
        creatingWorkspaceImage: mutation.isPending,
    };
};
